module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Home","portfolio":"Portfolio"},"ro":{"home":"Acasă","portfolio":"Portofoliu"}}')
  delete Component.options._Ctor
}
